export class LoginResourceModel {
    constructor (
        public readonly login: string,
        public readonly password?: string,
        public readonly sessionGuid?: string,
        public readonly refreshToken?: string
    ) {}
}
